/* ================================================================
   LegBilligt — gaveide-sidens vaerktojer
   1. Gavefinderen      (.lbgf)  starter med de mest kobte gaver,
                                 alder + belob byttter dem ud
   2. Sokende-vaegten   (.lbsv)  to sokende -> to gaver i samme pris
   3. Klassegaven       (.lbkg)  haandteres af lb-gave3.js

   BILLEDER: vi skifter forst kortene ud, nar billederne er hentet
   (maks 600 ms), og vi regner altid det NAESTE hold ud med det samme
   og forhenter det. Derfor foles "vis andre" ojeblikkeligt.
   Billedbredde 380 — skal matche lb-gave-forhent.js.
   Ingen MutationObserver.
   ================================================================ */
(function(){
  'use strict';

  var K = 'lb_onsker';
  var BRED = 380;
  var VENT = 600;
  /* KILDEN til aabningsbilledet — rettet 18-09-2026 fra 'gaveideer'.
     'gaveideer' har 8.500 varer, er sorteret efter mest solgte, og da
     butikken endnu ingen ordrer har, falder Shopify tilbage paa nyeste
     foerst. De nyeste 1.039 varer er alle udsolgt, saa hele side 1 af
     feedet var udsolgt, puljen blev tom, og Gavefinderen stod HELT TOM
     (koden gjorde 'if(!pulje.length) return' uden at vise noget).
     'gaver-paa-lager' er en automatisk kollektion: tag 'gave' OG lager > 0,
     sorteret efter mest solgte. Samme mening som foer — bare kun varer,
     kunden faktisk kan koebe. Den opdaterer sig selv.
     POPLINK: "Se alle gaveidéer" skal stadig pege paa den store kollektion. */
  var POP = 'gaver-paa-lager';
  var POPLINK = 'gaveideer';
  var POPTOP = 36;                /* vi trakker de seks fra toppen af listen */
  var HJERTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z"/></svg>';
  var puljer = {}, henter = {};

  function laes(){ try { return JSON.parse(localStorage.getItem(K)) || []; } catch(e){ return []; } }
  function paaSedlen(h){ return laes().indexOf(h) > -1; }

  function kr(n){ return n.toFixed(2).replace('.', ',') + ' kr'; }

  function lille(src, b){
    if(!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + b;
  }

  function forhent(u){ if(u){ var i = new Image(); i.decoding = 'async'; i.src = u; } }

  /* vent pa at billederne er i browserens cache — dog hojst VENT ms */
  function klargoer(varer, naar){
    var mangler = varer.length, kaldt = false;
    function faerdig(){
      if(kaldt) return;
      kaldt = true;
      naar();
    }
    if(!mangler){ faerdig(); return; }
    setTimeout(faerdig, VENT);
    varer.forEach(function(v){
      var i = new Image();
      i.decoding = 'async';
      i.onload = function(){ if(--mangler <= 0) faerdig(); };
      i.onerror = function(){ if(--mangler <= 0) faerdig(); };
      i.src = v.bil;
    });
  }

  function normaliser(p){
    var v = null, i;
    for(i = 0; i < p.variants.length; i++){
      if(p.variants[i].available){ v = p.variants[i]; break; }
    }
    if(!v) return null;
    var pris = parseFloat(v.price);
    if(!(pris > 0)) return null;
    var raa = (p.images && p.images[0]) ? p.images[0].src : '';
    if(!raa) return null;
    return {
      id: v.id, handle: p.handle, titel: p.title,
      url: '/products/' + p.handle, pris: pris,
      bil: lille(raa, BRED),
      flere: p.variants.length > 1
    };
  }

  function hentPulje(handle, sider){
    if(puljer[handle]) return Promise.resolve(puljer[handle]);
    if(henter[handle]) return henter[handle];
    var kald = sider.map(function(s){
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + s)
        .then(function(r){ return r.ok ? r.json() : {products:[]}; })
        .catch(function(){ return {products:[]}; });
    });
    henter[handle] = Promise.all(kald).then(function(svar){
      var ud = [];
      svar.forEach(function(s){
        (s.products || []).forEach(function(p){
          var n = normaliser(p);
          if(n) ud.push(n);
        });
      });
      puljer[handle] = ud;
      ud.slice(0, 12).forEach(function(v){ forhent(v.bil); });
      return ud;
    });
    return henter[handle];
  }

  function bland(a){
    for(var i = a.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function tonInd(rod){
    function faerdig(im){
      im.classList.add('klar');
      if(im.parentNode && im.parentNode.classList) im.parentNode.classList.add('klar');
    }
    rod.querySelectorAll('.im img').forEach(function(im){
      if(im.complete && im.naturalWidth > 0){ faerdig(im); return; }
      im.addEventListener('load', function(){ faerdig(im); });
      im.addEventListener('error', function(){ faerdig(im); });
    });
  }

  function hjerteHtml(v){
    return '<button type="button" class="lbo-hj' + (paaSedlen(v.handle) ? ' paa' : '') +
           '" data-h="' + v.handle + '" aria-label="Sæt på ønskesedlen">' + HJERTE + '</button>';
  }

  function kurvHtml(v){
    return v.flere
      ? '<span class="lbbr-kurv lbbr-kurv--v">Vælg variant</span>'
      : '<button type="button" class="lbbr-kurv" data-v="' + v.id + '">Læg i kurv</button>';
  }

  function kortHtml(v, klasse){
    return '<a class="' + klasse + '" href="' + v.url + '">' +
             '<span class="im" style="position:relative">' +
               '<img src="' + v.bil + '" alt="" decoding="async">' + hjerteHtml(v) +
             '</span>' +
             '<h4>' + v.titel + '</h4>' +
             '<div class="pr">' + kr(v.pris) + '</div>' +
             kurvHtml(v) +
           '</a>';
  }

  function opdaterKurvIkon(){
    var boble = document.getElementById('cart-icon-bubble');
    if(!boble) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(!d || !d['cart-icon-bubble']) return;
        var m = document.createElement('div');
        m.innerHTML = d['cart-icon-bubble'];
        var nyt = m.querySelector('#cart-icon-bubble');
        boble.innerHTML = nyt ? nyt.innerHTML : d['cart-icon-bubble'];
      })
      .catch(function(){});
  }

  function laegFlere(varer, knap){
    var org = knap.textContent;
    knap.disabled = true;
    knap.textContent = 'Lægger i kurv …';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: varer.map(function(v){ return { id: v.id, quantity: 1 }; }) })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      opdaterKurvIkon();
      knap.textContent = 'Lagt i kurven ✓';
      knap.classList.add('ok');
      setTimeout(function(){
        knap.textContent = org; knap.classList.remove('ok'); knap.disabled = false;
      }, 1800);
    })
    .catch(function(){
      knap.textContent = 'Prøv igen';
      setTimeout(function(){ knap.textContent = org; knap.disabled = false; }, 1800);
    });
  }

  /* ============================================================
     1. GAVEFINDEREN
     Boksen er aldrig tom: den abner med de mest kobte gaver.
     Nar bade alder og belob er valgt, byttes de seks ud.
     ============================================================ */
  function finder(rod){
    var alder = null, belob = null, navn = {};
    var res  = rod.querySelector('.lbgf-res');
    var hint = rod.querySelector('.lbgf-hint');
    var forud = null, forudH = null;

    function saetHint(){
      if(!hint) return;
      var t = '';
      if(alder && !belob)      t = 'Vælg også et beløb — så bytter vi gaverne herunder ud med seks til ' + navn.alder + '.';
      else if(belob && !alder) t = 'Vælg også hvem gaven er til — så bytter vi gaverne herunder ud.';
      hint.textContent = t;
      hint.hidden = (t === '');
    }

    rod.querySelectorAll('.lbgf-c').forEach(function(b){
      b.addEventListener('click', function(){
        var gruppe = b.dataset.alder ? 'alder' : 'pris';
        rod.querySelectorAll('.lbgf-c').forEach(function(o){
          var og = o.dataset.alder ? 'alder' : 'pris';
          if(og === gruppe) o.classList.remove('valgt');
        });
        b.classList.add('valgt');
        if(gruppe === 'alder'){ alder = b.dataset.alder; navn.alder = b.textContent; }
        else { belob = b.dataset.pris; navn.pris = b.textContent; }
        saetHint();
        if(alder && belob) find();
      });
    });

    /* --- abningsbilledet: de mest kobte --- */
    function populaere(){
      hentPulje(POP, [1]).then(function(pulje){
        if(!pulje.length) return;
        if(alder && belob) return;              /* kunden naaede at vaelge */
        var top = pulje.slice(0, POPTOP);
        var valgt = bland(top.slice(0)).slice(0, 6);
        klargoer(valgt, function(){
          if(alder && belob) return;
          vis(valgt, POP, true);
        });
      });
    }

    function find(){
      var handle = 'gave-' + alder + '-' + belob;
      if(!res.querySelector('.lbgf-seks')) res.innerHTML = '<p class="lbgf-vent">Finder gaver …</p>';
      hentPulje(handle, [1, 2]).then(function(pulje){
        if(!pulje.length){
          res.innerHTML = '<p class="lbgf-vent">Vi har ikke noget i den kombination lige nu. Prøv et andet beløb.</p>';
          return;
        }
        var valgt = (forud && forudH === handle) ? forud : bland(pulje.slice(0)).slice(0, 6);
        klargoer(valgt, function(){ vis(valgt, handle, false); });
        forud = bland(pulje.slice(0)).slice(0, 6);
        forudH = handle;
        forud.forEach(function(v){ forhent(v.bil); });
      });
    }

    function vis(varer, handle, pop){
      var mrkat = pop
        ? 'Mest købte gaver lige nu'
        : (navn.alder || '') + ' &middot; ' + (navn.pris || '').toLowerCase();
      var h = '<span class="lbgf-mrkat">' + mrkat + '</span><div class="lbgf-seks">';
      varer.forEach(function(v){ h += kortHtml(v, 'lbgf-k'); });
      h += '</div><div class="lbgf-bund">' +
             '<button type="button" class="lbgf-igen">Vis seks andre</button>' +
             '<a class="lbgf-alle" href="/collections/' + (pop ? POPLINK : handle) + '">' +
               (pop ? 'Se alle gaveidéer' : 'Se alle ' + (navn.alder || '') + ' til ' + (navn.pris || '').toLowerCase()) +
             ' &rsaquo;</a>' +
           '</div>';
      res.innerHTML = h;
      tonInd(res);
      res.querySelector('.lbgf-igen').addEventListener('click', function(){
        if(alder && belob) find(); else populaere();
      });
    }

    populaere();
  }

  /* ============================================================
     2. SOKENDE-VAEGTEN
     ============================================================ */
  function vaegten(rod){
    var a1 = null, a2 = null, belob = null;
    var res = rod.querySelector('.lbsv-res');
    var forud = null, forudN = null, forudF = 0;

    rod.querySelectorAll('.lbsv-c').forEach(function(b){
      b.addEventListener('click', function(){
        var g = b.dataset.gruppe;
        rod.querySelectorAll('.lbsv-c[data-gruppe="' + g + '"]').forEach(function(o){ o.classList.remove('valgt'); });
        b.classList.add('valgt');
        if(g === 'a1') a1 = b.dataset.v;
        else if(g === 'a2') a2 = b.dataset.v;
        else belob = b.dataset.v;
        if(a1 && a2 && belob) find();
        else res.innerHTML = '<p class="lbgf-vent">Vælg alder på begge — og hvad I vil bruge pr. barn.</p>';
      });
    });

    function vaelgPar(A, B){
      var bedst = null, mindst = 1e9, i, x, y, d;
      for(i = 0; i < 2500; i++){
        x = A[Math.floor(Math.random() * A.length)];
        y = B[Math.floor(Math.random() * B.length)];
        if(x.handle === y.handle) continue;
        d = Math.abs(x.pris - y.pris);
        if(d < mindst){ mindst = d; bedst = [x, y]; }
        if(mindst < 0.02) break;
      }
      return bedst ? { par: bedst, forskel: mindst } : null;
    }

    function find(){
      var noegle = a1 + '|' + a2 + '|' + belob;
      if(!res.querySelector('.lbsv-par')) res.innerHTML = '<p class="lbgf-vent">Vejer gaverne af mod hinanden …</p>';
      var hA = 'gave-' + a1 + '-' + belob;
      var hB = 'gave-' + a2 + '-' + belob;
      Promise.all([hentPulje(hA, [1, 2]), hentPulje(hB, [1, 2])]).then(function(p){
        var A = p[0], B = p[1];
        if(A.length < 2 || B.length < 2){
          res.innerHTML = '<p class="lbgf-vent">Vi har ikke nok i den kombination lige nu. Prøv et andet beløb.</p>';
          return;
        }
        var brug;
        if(forud && forudN === noegle){ brug = { par: forud, forskel: forudF }; }
        else { brug = vaelgPar(A, B); }
        if(!brug) return;
        klargoer(brug.par, function(){ vis(brug.par, brug.forskel); });

        var naeste = vaelgPar(A, B);
        if(naeste){
          forud = naeste.par; forudF = naeste.forskel; forudN = noegle;
          naeste.par.forEach(function(v){ forhent(v.bil); });
        }
      });
    }

    function vis(par, forskel){
      var sum = par[0].pris + par[1].pris;
      var enig = forskel < 0.02;
      var h = '<div class="lbsv-par">' +
                kortHtml(par[0], 'lbsv-k') +
                '<div class="lbsv-midt"><span class="lbsv-vs">' + (enig ? 'Samme pris' : 'Forskel') + '</span>' +
                  '<b>' + (enig ? '0 kr.' : kr(forskel)) + '</b>' +
                '</div>' +
                kortHtml(par[1], 'lbsv-k') +
              '</div>' +
              '<div class="lbgf-bund">' +
                '<div class="lbsv-sum"><span>I alt</span><b>' + kr(sum) + '</b></div>' +
                (par[0].flere || par[1].flere
                  ? '<span class="lbsv-note">En af dem findes i flere varianter — vælg den inde på varen.</span>'
                  : '<button type="button" class="lbsv-add">Læg begge i kurven</button>') +
                '<button type="button" class="lbsv-igen">Find to andre</button>' +
              '</div>';
      res.innerHTML = h;
      tonInd(res);
      var add = res.querySelector('.lbsv-add');
      if(add) add.addEventListener('click', function(){ laegFlere(par, add); });
      res.querySelector('.lbsv-igen').addEventListener('click', find);
    }
  }

  /* ---------- start ---------- */
  function start(){
    document.querySelectorAll('.lbgf').forEach(function(el){
      if(el.dataset.klar) return; el.dataset.klar = '1'; finder(el);
    });
    document.querySelectorAll('.lbsv').forEach(function(el){
      if(el.dataset.klar) return; el.dataset.klar = '1'; vaegten(el);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();